import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useClickRef } from '@make-software/csprclick-ui';

import { ConnectedAccountContext } from '@/contexts/ConnectedAccountContext';
import { BuyStampsModal } from '@/components';
import {
  Background,
  HeroTitle,
  HeroSubtitle,
  Button,
  Section
} from './styled';

export const HeroSection: React.FC = () => {
  const [showBuyStampsModal, setShowBuyStampsModal] = useState<boolean>(false);
  const connectedAccount = useContext(ConnectedAccountContext);
  const clickRef = useClickRef();

  const { hash } = useLocation();
  useEffect(() => {
    const match = hash.match(/^#message\/(.+)$/);
    if (match) {
      console.log('Open message', match[1]);
    }
  }, [hash]);

  return (
    <Background>
      <Section>
        <HeroTitle>Encrypted on-chain messaging</HeroTitle>
        <HeroSubtitle>From one account to another</HeroSubtitle>

        {connectedAccount
          ? <Button onClick={() => setShowBuyStampsModal(true)}>
            Compose
          </Button>
          : <Button onClick={() => clickRef?.signIn()}>
            Connect Wallet
          </Button>
        }
      </Section>

      <BuyStampsModal
        isOpen={showBuyStampsModal}
        onClose={() => setShowBuyStampsModal(false)}
      />
    </Background>
  );
};
